// extracted by mini-css-extract-plugin
export default {"container":"SplitContainer_container__dQhZu"};